import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { log, error as logError } from '../utils/DebugLogger';

import '../contracts/Orders_ConfirmExitReportInput';
import '../contracts/Orders_ConfirmExitReportResponse';
import '../contracts/Orders_ExitReportResponse';
import type { Orders_ConfirmExitReportInput } from '../contracts/Orders_ConfirmExitReportInput';
/**
 * Composable for SO Exit Report operations.
 * Manages exit report photos, observations, and confirmation
 * for the quality control / delivery workflow.
 */
export function useSOExitReports() {
  const isLoading = ref(false);
  const error = ref(null);
  const basePath = '/index.php/so/orders';

  const getExitReport = async (orderItemId: number) => {
    log('useSOExitReports', 'getExitReport', 'Fetching exit report', { orderItemId });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.get(`${basePath}/exit_report/${orderItemId}`, { responseContract: 'Orders_ExitReportResponse' });
      if (response.success) {
        return response.dados;
      }
      throw new Error(response.error || 'Erro ao buscar laudo de saida');
    } catch (err) {
      logError('useSOExitReports', 'getExitReport', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  const confirmExitReport = async (orderItemId: Orders_ConfirmExitReportInput['order_item_id'], observations: Orders_ConfirmExitReportInput['observations'], finalStatus: Orders_ConfirmExitReportInput['final_status']) => {
    log('useSOExitReports', 'confirmExitReport', 'Confirming exit report', { orderItemId, finalStatus });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.put(`${basePath}/confirm_exit_report`, {
        order_item_id: orderItemId,
        observations,
        final_status: finalStatus
      }, { inputContract: 'Orders_ConfirmExitReportInput', responseContract: 'Orders_ConfirmExitReportResponse' });
      if (response.success) {
        return response;
      }
      throw new Error(response.error || 'Erro ao confirmar laudo de saida');
    } catch (err) {
      logError('useSOExitReports', 'confirmExitReport', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };


  return {
    isLoading,
    error,
    getExitReport,
    confirmExitReport
  };
}
